/** @file InfoTip: an (i) button that opens a small popover of one-line rules; click again or Esc closes it. */
import type { ReactElement } from 'react';
import { useState } from 'react';

/** `label` names the button, `lines` are the popover's rows (one rule each). */
export type InfoTipProps = { label: string; lines: readonly string[] };

/** Focus leaving the button and popover also closes it; Esc closes it and is not passed on to the shell. */
export function InfoTip({ label, lines }: InfoTipProps): ReactElement {
  const [open, setOpen] = useState(false);
  return (
    <span style={{ position: 'relative', display: 'inline-block' }}
      onKeyDown={(e) => { if (open && e.code === 'Escape') { e.stopPropagation(); setOpen(false); } }}
      onBlur={(e) => { if (!(e.relatedTarget instanceof Node && e.currentTarget.contains(e.relatedTarget))) setOpen(false); }}>
      <button type="button" aria-label={label} aria-expanded={open} title={label}
        style={{ font: 'inherit', fontSize: 11, lineHeight: 1, width: 18, height: 18, padding: 0, borderRadius: 9, cursor: 'pointer',
          color: 'var(--p3-info, #7fd1ff)', background: 'transparent', border: '1px solid var(--p3-border, #2a2e38)' }}
        onClick={(e) => { e.preventDefault(); setOpen(!open); }}>i</button>
      {open && (
        <ul role="note" aria-label={label}
          style={{ position: 'absolute', right: 0, top: 22, zIndex: 20, width: 250, maxWidth: '80vw', margin: 0, padding: '6px 8px 6px 20px', listStyle: 'disc',
            fontWeight: 400, fontSize: 11, color: 'var(--p3-text, #e6e6e6)', background: 'var(--p3-panel, #191c22)',
            border: '1px solid var(--p3-border, #2a2e38)', borderRadius: 6, boxShadow: '0 4px 14px #0008', overflowWrap: 'anywhere' }}>
          {lines.map((line) => <li key={line}>{line}</li>)}
        </ul>
      )}
    </span>
  );
}
